import { GridCustomCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { RadioButton, RadioButtonChangeEvent } from '@progress/kendo-react-inputs';
import { CpsGridCell } from './CpsGridCell';
import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';

interface RadioButtonCellProps extends GridCustomCellProps {
  onRadioButtonChange?: (value: boolean) => void;
  disabled?: boolean;
}

export const RadioButtonCell: React.FC<RadioButtonCellProps> = props => {
  const { disabled, onRadioButtonChange } = props;
  const field = props.field;
  const selectedValue = field ? props.dataItem[field] : false;
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <CpsGridCell
      dataItem={props.dataItem}
      field={props.field}
      dataIndex={props.dataIndex}
      id={props.id}
      tdProps={props.tdProps}
      columnPosition={props.columnPosition}
      onChange={props.onChange}
      className={props.className}
      colSpan={props.colSpan}
      ariaColumnIndex={props.ariaColumnIndex}
      isSelected={props.isSelected}
      style={props.style}
      rowType={props.rowType}
      level={props.level}
      expanded={props.expanded}
      title={translate(`custom.common.${selectedValue ? 'yes' : 'no'}`)}
    >
      <div className={disabled ? 'radioButtonDisabled' : 'radioButtonActive'}>
        <RadioButton
          checked={selectedValue}
          disabled={disabled}
          onChange={(event: RadioButtonChangeEvent) => {
            if (onRadioButtonChange) {
              onRadioButtonChange(event.value);
            }
          }}
        />
      </div>
    </CpsGridCell>
  );
};
